module.exports = __webpack_public_path__ + "img/TXT-SOCIAL-BLOG.be330106.png";